import { render } from "./encase.vue?vue&type=template&id=4121cc09&scoped=true"
import script from "./encase.vue?vue&type=script&lang=js"
export * from "./encase.vue?vue&type=script&lang=js"

import "./encase.vue?vue&type=style&index=0&id=4121cc09&scoped=true&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4121cc09"]])

export default __exports__